/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Provider_Not_LinkedInputs */



/**
* | output |
* | --- |
* | "Sign in once with an email link. After that, Google and Microsoft will work." |
*
* @param {Login_Provider_Not_LinkedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_provider_not_linked = /** @type {((inputs?: Login_Provider_Not_LinkedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Provider_Not_LinkedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meld je één keer aan met een e-maillink. Daarna werken Google en Microsoft.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous une première fois avec un lien e-mail. Ensuite, Google et Microsoft fonctionneront.")
	return /** @type {LocalizedString} */ ("Sign in once with an email link. After that, Google and Microsoft will work.")
});